namespace TabAurous.OMS {
    export namespace RateMasterService {
        export const baseUrl = 'OMS/RateMaster';

        export declare function Create(request: Serenity.SaveRequest<RateMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<RateMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<RateMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<RateMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetRate(request: RateRequest, onSuccess?: (response: Serenity.ListResponse<RateMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetItemRate(request: RateRequest, onSuccess?: (response: Serenity.ListResponse<Common.RateResponse>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/RateMaster/Create",
            Update = "OMS/RateMaster/Update",
            Delete = "OMS/RateMaster/Delete",
            Retrieve = "OMS/RateMaster/Retrieve",
            List = "OMS/RateMaster/List",
            GetRate = "OMS/RateMaster/GetRate",
            GetItemRate = "OMS/RateMaster/GetItemRate"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetRate', 
            'GetItemRate'
        ].forEach(x => {
            (<any>RateMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
